// Code generated from omniwound_core_authorization.proto. DO NOT EDIT.

/** Human Account Types admitted after the expansion phase. */
export const HUMAN_ACCOUNT_TYPES = {
  PROVIDER: 'provider',
  STAFF: 'staff',
} as const;

export type HumanAccountType =
  (typeof HUMAN_ACCOUNT_TYPES)[keyof typeof HUMAN_ACCOUNT_TYPES];

export const HUMAN_ACCOUNT_TYPE_VALUES = Object.values(
  HUMAN_ACCOUNT_TYPES,
) as readonly HumanAccountType[];

/** Numeric protobuf values generated from the same enum source. */
export const HUMAN_ACCOUNT_TYPE_PROTO_VALUES: Readonly<
  Record<HumanAccountType, number>
> = {
  'provider': 1,
  'staff': 2,
};

/** Exact realm-role set retained only during the admin-to-Staff migration. */
export const OMNIWOUND_TRANSITIONAL_REALM_ROLES = {
  ADMIN: 'admin',
  PROVIDER: 'provider',
  STAFF: 'staff',
} as const;

export type TransitionalRealmRole =
  (typeof OMNIWOUND_TRANSITIONAL_REALM_ROLES)[keyof typeof OMNIWOUND_TRANSITIONAL_REALM_ROLES];

export const OMNIWOUND_TRANSITIONAL_REALM_ROLE_VALUES = Object.values(
  OMNIWOUND_TRANSITIONAL_REALM_ROLES,
) as readonly TransitionalRealmRole[];

/** Closed, audience-specific Capability vocabulary. */
export const OMNIWOUND_CAPABILITIES = {
  UNSIGNED_NOTE_DISCARD: 'unsigned-note-discard',
  BOOTSTRAP_EVIDENCE_RECONCILE: 'bootstrap-evidence-reconcile',
  GRANT_AUTHORITY: 'grant-authority',
  ACCESS_ASSIGNMENT_REVOKE: 'access-assignment-revoke',
  ACCOUNT_LIFECYCLE_MANAGE: 'account-lifecycle-manage',
  CREDENTIAL_SESSION_MANAGE: 'credential-session-manage',
  PRACTITIONER_BINDING_MANAGE: 'practitioner-binding-manage',
  QA_REVIEW: 'qa-review',
  SIGNED_NOTE_PDF_READ: 'signed-note-pdf-read',
  APPOINTMENT_AVAILABILITY_READ: 'appointment-availability-read',
  PATIENT_INTAKE: 'patient-intake',
} as const;

export type OmniWoundCapability =
  (typeof OMNIWOUND_CAPABILITIES)[keyof typeof OMNIWOUND_CAPABILITIES];

export const OMNIWOUND_CAPABILITY_VALUES = Object.values(
  OMNIWOUND_CAPABILITIES,
) as readonly OmniWoundCapability[];

/** Numeric protobuf values generated from the same enum source. */
export const OMNIWOUND_CAPABILITY_PROTO_VALUES: Readonly<
  Record<OmniWoundCapability, number>
> = {
  'unsigned-note-discard': 1,
  'bootstrap-evidence-reconcile': 2,
  'grant-authority': 3,
  'access-assignment-revoke': 4,
  'account-lifecycle-manage': 5,
  'credential-session-manage': 6,
  'practitioner-binding-manage': 7,
  'qa-review': 8,
  'signed-note-pdf-read': 9,
  'appointment-availability-read': 10,
  'patient-intake': 11,
};

/**
 * Provider operation Capabilities projected from the reviewed ODRL Set.
 * Staff authority is resolved from ODRL Agreements by omniwound-core.
 */
export const PROVIDER_OPERATION_CAPABILITIES_V1 = [
  OMNIWOUND_CAPABILITIES.UNSIGNED_NOTE_DISCARD,
  OMNIWOUND_CAPABILITIES.BOOTSTRAP_EVIDENCE_RECONCILE,
  OMNIWOUND_CAPABILITIES.SIGNED_NOTE_PDF_READ,
  OMNIWOUND_CAPABILITIES.APPOINTMENT_AVAILABILITY_READ,
] as const satisfies readonly OmniWoundCapability[];

/**
 * Product-approved Staff Capability Catalog v1.
 * Guarded operation permissions not listed here cannot be assigned through a
 * Staff Access Profile.
 */
export const STAFF_CAPABILITY_CATALOG_V1 = {
  GRANT_AUTHORITY: 'grant-authority',
  ACCESS_ASSIGNMENT_REVOKE: 'access-assignment-revoke',
  ACCOUNT_LIFECYCLE_MANAGE: 'account-lifecycle-manage',
  CREDENTIAL_SESSION_MANAGE: 'credential-session-manage',
  PRACTITIONER_BINDING_MANAGE: 'practitioner-binding-manage',
} as const;

/**
 * Product-approved Staff Capability Catalog v2.
 * Adds provider-scoped QA Review without changing the immutable v1 snapshot.
 */
export const STAFF_CAPABILITY_CATALOG_V2 = {
  GRANT_AUTHORITY: 'grant-authority',
  ACCESS_ASSIGNMENT_REVOKE: 'access-assignment-revoke',
  ACCOUNT_LIFECYCLE_MANAGE: 'account-lifecycle-manage',
  CREDENTIAL_SESSION_MANAGE: 'credential-session-manage',
  PRACTITIONER_BINDING_MANAGE: 'practitioner-binding-manage',
  QA_REVIEW: 'qa-review',
} as const;

/**
 * Product-approved Staff Capability Catalog v3.
 * Adds Patient Intake without changing the immutable v1 or v2 snapshots.
 */
export const STAFF_CAPABILITY_CATALOG_V3 = {
  GRANT_AUTHORITY: 'grant-authority',
  ACCESS_ASSIGNMENT_REVOKE: 'access-assignment-revoke',
  ACCOUNT_LIFECYCLE_MANAGE: 'account-lifecycle-manage',
  CREDENTIAL_SESSION_MANAGE: 'credential-session-manage',
  PRACTITIONER_BINDING_MANAGE: 'practitioner-binding-manage',
  QA_REVIEW: 'qa-review',
  PATIENT_INTAKE: 'patient-intake',
} as const;

export type StaffCapability =
  (typeof STAFF_CAPABILITY_CATALOG_V3)[keyof typeof STAFF_CAPABILITY_CATALOG_V3];

export const STAFF_CAPABILITY_CATALOG_V1_VALUES = Object.values(
  STAFF_CAPABILITY_CATALOG_V1,
) as readonly StaffCapability[];

export const STAFF_CAPABILITY_CATALOG_V2_VALUES = Object.values(
  STAFF_CAPABILITY_CATALOG_V2,
) as readonly StaffCapability[];

export const STAFF_CAPABILITY_CATALOG_V3_VALUES = Object.values(
  STAFF_CAPABILITY_CATALOG_V3,
) as readonly StaffCapability[];

/**
 * @deprecated Use HUMAN_ACCOUNT_TYPES for identity and
 * OMNIWOUND_CAPABILITIES for authority.
 */
export const OMNIWOUND_ROLES = OMNIWOUND_TRANSITIONAL_REALM_ROLES;

/** @deprecated Use HumanAccountType or TransitionalRealmRole explicitly. */
export type OmniWoundRole = TransitionalRealmRole;

/** @deprecated Use HUMAN_ACCOUNT_TYPE_VALUES after ticket 52. */
export const OMNIWOUND_ROLE_VALUES =
  OMNIWOUND_TRANSITIONAL_REALM_ROLE_VALUES;

export * from './authorization-attempt';
export * from './authorization-attempt-holder';
export * from './authorization-intent-outcome';
export * from './browser-authorization';
export * from './operation-registry.generated';
export * from './staff-access-profile.generated';
